import React, { useRef, useEffect } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import WhatWeDo from '../components/WhatWeDo';
import WhoWeWorkWith from '../components/WhoWeWorkWith';
import RecentWorks from '../components/RecentWorks';
import Counter from '../components/Counter';
import DesignTools from '../components/DesiginTools';
import DesignFuture from '../components/DesignFuture';
import WhoAreWe from '../components/WhoAreWe';
import Footer from '../components/Footer';
import TestimonialsSection from '../components/TestimonialsSection';

// Wrapper component for animated sections
const AnimatedSection = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { 
          opacity: 1, 
          y: 0,
          transition: { 
            duration: 0.0, 
            ease: "easeOut",
            delay: delay 
          }
        }
      }}
      style={{ width: '100%' }}
    >
      {children}
    </motion.div>
  );
};

const Home = () => (
  <>
    <Header />
    <main style={{ width: '100%', overflow: 'hidden' }}>
      <AnimatedSection>
        <HeroSection />
      </AnimatedSection>
      
        <WhatWeDo />
      
      <AnimatedSection delay={0.1}>
        <Counter />
      </AnimatedSection>

      <AnimatedSection delay={0.1}>
        <WhoWeWorkWith />
      </AnimatedSection>
      
      <AnimatedSection delay={0.1}>
        <RecentWorks />
      </AnimatedSection>
      
      <AnimatedSection delay={0.1}>
        <DesignFuture />
      </AnimatedSection>
      
      <AnimatedSection delay={0.1}>
        <WhoAreWe />
      </AnimatedSection>
      
      {/* <AnimatedSection delay={0.1}>
        <TestimonialsSection />
      </AnimatedSection> */}
    </main>
    <Footer />
  </>
);

export default Home;